import { Box, Chip, styled } from '@mui/material';

export const DetailRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  fontSize: '0.813rem',
});

export const DetailIcon = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  color: theme.palette.text.secondary,
  '& svg': {
    fontSize: '16px',
  },
}));

export const StyledChip = styled(Chip)({
  height: '20px',
  fontSize: '0.688rem',
  fontWeight: 500,
  '& .MuiChip-label': {
    padding: '0 8px',
    lineHeight: '20px',
    display: 'flex',
    alignItems: 'center',
  },
});
